export default __webpack_public_path__ + "static/top-fcd50d2b04ed26130fc029494b997c62.png";